export enum UserRoles {
  AdminRole = 'administrador',
  SupportRole = 'soporte',
  EmployeeRole = 'empleado',
}

export const { AdminRole, EmployeeRole, SupportRole } = UserRoles;

export const AllRoles = [AdminRole, EmployeeRole, SupportRole];
